import { canAccessMenuItem } from "../utils/menuUtils";

const NAV_BY_ROLE = {
  admin: [
    {
      path: "/",
      label: "Dashboard",
      iconKey: "dashboard",
      module: "dashboard",
      isActive: (pathname) => pathname === "/",
    },
    {
      path: "/company",
      label: "Organization",
      iconKey: "business",
      module: "company_list",
      isActive: (pathname) => pathname.includes("/company"),
    },
    {
      path: "/employer",
      label: "Employer",
      iconKey: "work",
      module: "employer_management",
      isActive: (pathname) => pathname.includes("/employer"),
    },
    {
      path: "/payrolls",
      label: "Payroll",
      iconKey: "payments",
      module: "payrolls",
      isActive: (pathname) =>
        pathname.includes("/payroll") || pathname.includes("/pay-slip"),
    },
    {
      path: "/reports",
      label: "Reports",
      iconKey: "assessment",
      module: "report_management",
      isActive: (pathname) => pathname.includes("/reports"),
    },
  ],
  employer: [
    {
      path: "/",
      label: "Dashboard",
      iconKey: "dashboard",
      module: "dashboard",
      isActive: (pathname) => pathname === "/",
    },
    {
      path: "/users",
      label: "Employees",
      iconKey: "people",
      module: "employee_list",
      isActive: (pathname) => pathname.includes("/users"),
    },
    {
      path: "/pay-slips",
      label: "Payslips",
      iconKey: "receipt",
      module: "pay_slips",
      isActive: (pathname) =>
        pathname.includes("/pay-slip") || pathname.includes("/Payslip"),
    },
    {
      path: "/time-attendance",
      label: "Attendance",
      iconKey: "schedule",
      module: "attendance_management",
      isActive: (pathname) =>
        pathname.includes("/time-attendance") ||
        (pathname.includes("/attendance") &&
          !pathname.includes("/employee_attendance")),
    },
    {
      path: "/leaves",
      label: "Leaves",
      iconKey: "event",
      module: "leave_list",
      isActive: (pathname) =>
        pathname === "/leaves" || pathname.startsWith("/leaves/"),
    },
    {
      path: "/reports",
      label: "Reports",
      iconKey: "assessment",
      module: "report_management",
      isActive: (pathname) => pathname.includes("/reports"),
    },
  ],
  employee: [
    {
      path: "/",
      label: "Dashboard",
      iconKey: "dashboard",
      module: "dashboard",
      isActive: (pathname) => pathname === "/",
    },
    {
      path: "/employee_attendance",
      label: "Attendance",
      iconKey: "schedule",
      module: "employee_attendance",
      isActive: (pathname) =>
        pathname === "/employee_attendance" ||
        pathname.startsWith("/employee_attendance/"),
    },
    {
      path: "/employee_Payslips",
      label: "Payslips",
      iconKey: "receipt",
      module: "employee_payslips",
      isActive: (pathname) =>
        pathname === "/employee_Payslips" ||
        pathname.startsWith("/employee_Payslips/"),
    },
    {
      path: "/leaves",
      label: "Leave",
      iconKey: "event",
      module: "leave_list",
      isActive: (pathname) =>
        pathname === "/leaves" || pathname.startsWith("/leaves/"),
    },
    {
      path: "/employee_task_issue",
      label: "Tasks",
      iconKey: "task",
      module: "employee_task_issue",
      isActive: (pathname) =>
        pathname === "/employee_task_issue" ||
        pathname.startsWith("/employee_task_issue/"),
    },
  ],
};

const MAX_BOTTOM_NAV_ITEMS = 5;

export const getMobileBottomNavItems = (userType, permissions) => {
  const role = (userType || "").trim().toLowerCase();
  const candidates = NAV_BY_ROLE[role] || NAV_BY_ROLE.employer;

  return candidates
    .filter((item) => canAccessMenuItem({ module: item.module }, userType, permissions))
    .slice(0, MAX_BOTTOM_NAV_ITEMS);
};

export default NAV_BY_ROLE;
